<div class="row">
  <div class="col-xxl-5 col-md-7 box-col-7">
    <app-order-board></app-order-board>
  </div>
  <div class="col-xxl-3 col-md-5 col-sm-6 box-col-5">
    <app-valuable-customer></app-valuable-customer>
  </div>
  <div class="col-xxl-4 col-sm-6 box-col-6">
    <app-monthly-order></app-monthly-order>
  </div>
  <div class="col-xxl-3 col-md-6 box-col-6">
    <app-monthly-profits></app-monthly-profits>
  </div>
  <div class="col-xxl-9 box-col-12">
    <app-order-overview></app-order-overview>
  </div>
  <div class="col-xxl-3 col-xl-4 col-sm-6 box-col-6 wow zoomIn">
    <app-discover-pro></app-discover-pro>
  </div>
  <div class="col-xxl-4 col-xl-4 col-sm-6 box-col-6">
    <app-visitors></app-visitors>
  </div>
  <div class="col-xxl-5 col-xl-4 box-col-12">
    <app-recent-orders-table></app-recent-orders-table>
  </div>
</div>
